<template>
  <div class="flex gap-3 rounded-card border p-3.5 text-label leading-snug [&_p]:m-0" :class="TONE[tone]">
    <i :class="`pt-1 tr tr-${icon} shrink-0 text-xl leading-none`"></i>
    <div class="flex flex-col gap-1.5">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    required: true,
  },
  tone: {
    type: String,
    default: 'accent',
    validator: (value) => ['accent', 'warning', 'danger'].includes(value),
  },
});

const TONE = {
  accent: 'border-accent/30 bg-accent-soft text-text',
  warning: 'border-amber/30 bg-amber/15 text-text',
  danger: 'border-red/30 bg-red-soft text-text',
};
</script>
